import { useState, useEffect } from 'react';

import Join from '../../components/renconcilationtype/Join';
import { isValidConfig, buildConfig } from './utils';

const JoinContainer = ({
    configData, saveData, subOperation, setError,
}) => {
    const [updatedConfigData, setUpdatedConfigData] = useState([]);
    const [subOperator, setSubOperator] = useState(subOperation);

    /* callback function called when updatedConfigData is changed */
    const onJoinSaveConfig = () => {
        if (updatedConfigData.length > 0) {
            const config = buildConfig(updatedConfigData, 'Join');
            // function to save the recon configuration
            saveData({
                flow: {
                    ...config,
                    subOperation: subOperator,
                },
            });
        }
    };

    /* map selected columns where isJoin is set */
    const joinColumns = updatedConfigData.map(uc => ({
        ...uc,
        selectedColumns: uc.selectedColumns.filter(data => data.isJoin),
    }));

    /* side effect when configData is changed */
    useEffect(() => {
        const { message } = isValidConfig(configData);
        if (message !== '') {
            setError({ message });
        } else {
            setUpdatedConfigData(configData);
        }
    }, [configData]);

    /* side effect when updatedConfigData is changed */
    useEffect(() => {
        onJoinSaveConfig();
    }, [updatedConfigData]);

    /* callback function called when Join config is changed */
    const onHandleChange = event => {
        const { target: { name, checked, id } } = event;
        setUpdatedConfigData(prevState => {
            let data = [...prevState];
            data = data.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        selectedColumns: item.selectedColumns.map(sc => (sc.column === name ? { ...sc, isJoin: checked } : sc)),
                    };
                }
                return item;
            });
            return data;
        });
    };

    /* callback function called when Join type is selected */
    const onChecked = (event, value) => {
        setSubOperator(value);
    };

    return (
        <Join
            updatedConfigData={updatedConfigData}
            subOperator={subOperator}
            onChecked={onChecked}
            onHandleChange={onHandleChange}
            joinColumns={joinColumns}
        />
    );
};

export default JoinContainer;
